module.exports = __webpack_public_path__ + "img/cognitive_img03.debdf83d.jpg";